import gql from "graphql-tag"

const query = gql`
  query CanRedeemBasket($userId: ID!) {
    canRedeemBasket(userId: $userId)
  }
`

export default query
